/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react'
import StepperDefault from '../../../components/stepper';
import Styles from "./styles.module.scss";
import ellowLogo from "../../../assets/images/ellow-logo.svg";
import Headline4 from '../../../components/headings/Headline4';
import CompanyDetails from "./companydetails";
import ContactDetails from './contactdetails';
import NotificationAlert from '../../../components/notification';
import { addProviderDetails, getCompanyDetails, getUserDetails, updateProviderDetails , getProviderDomains } from './services';
import { useNavigate } from 'react-router-dom';
import mixpanelData, { viewedpageMixpanel } from '../../../utils/mixpanel';
import { getAPI } from '../../../api';

function Registration() {
  
    const navigate = useNavigate()
    const [active_status , setActive_status] = useState<any>()
    const [step, setStep] = useState<number>(0)
    const [status, setStatus] = useState<any>()
    const [apiStatus, setApiStatus] = useState<any>()
    const [flag, setFlag] = useState<boolean>(false)
    const [customerId, setCustomerId] = useState<string>()
    const [defaultContactValues, setDefaultContactValues] = useState<{ workEmail: string, phoneNumber: string, companyName: string, firstName: string}>({ workEmail: '', phoneNumber: '', companyName:'', firstName:''})
    const [isExistingCustomer, setIsExistingCustomer] = useState<boolean>(false)
    const [defaultCompanyValues, setDefaultCompanyValues] = useState<{
      services: {id: number , name: string}[],
      domain: {id: number , name: string}[],
      skills: {id: number , name: string}[],
    }>({ services:[{id:0, name:''}], domain:[{id:0, name:''}], skills:[{id:0, name:''}]}) 
    const [email, setEmail] = useState<string>('')
    const [message, setMessage] = useState<string>('')
    const [notification, setNotification] = useState<boolean>(false)
    const [userId, setUserId] = useState<string>('')
    const [companyFlag, setCompanyFlag] = useState<boolean>(false)
    const [providerDomains, setProviderDomains] = useState<any>()
    const [domainsList, setPDomainsList] = useState<any>()
    const [jobRoleList, setJobRoleList] = useState<any>()
    const [skillList, setSkillList] = useState<any>()
    const [blackListed, setBlackListed] = useState<boolean>(false)
    const [type, setType] = useState<string>('success')
    const [icon, setIcon] = useState<boolean>(true)
    useEffect(() => {
     
      viewedpageMixpanel()
      getProviderDomainsList()
      viewedpageMixpanel()

      getAPI('https://api.ellow.io/common//api/v1/ml/job-roles').then((resp: any) => {
        if (resp && resp.status === 1) {
          setJobRoleList(resp.data)
        }
      })
  
      getAPI('https://api.ellow.io/common/api/v1/ml/skills').then((value: any) => {
        if (value && value.status === 1) {
          setSkillList(value.data)
        }
      })

    },[])

    const getProviderDomainsList = () => {
      
        getProviderDomains().then((response: any) => {
          if(response && response.status === 1){
            const list = response.data && response.data.length > 0 && response.data.map((item: any) => {
              return ({name:item.domain_name, id: item.domain_id})
            })       
            setProviderDomains(list.slice(7))
            const list1 = list.slice(0,6)
            list1.push({name: "Others",id: 0})  
            setPDomainsList(list1)
          }
        }) 
    }
    
    const getCustomerDetails = (email: string) => {
   
      getUserDetails(email).then((response) => {  
        //<<MATCHING EMAIL>>// 
        if ( response && response.status === 2) {
          setFlag(true)
          setApiStatus(response.status)
          setCustomerId(response.data[0] && response.data[0].customer_id)
          setStatus(response.data[0] && response.data[0].customer_status)
          if (response.data[0].userData) {
            if (response.data[0] && response.data[0].userData && response.data[0].userData[0].customer_metadata.workEmail) {
              setEmail(response.data[0] && response.data[0].userData && response.data[0].userData[0].customer_metadata.workEmail)
              let domain = response.data[0] && response.data[0].userData && response.data[0].userData[0].customer_metadata.workEmail.split('@')[1]
              if (domain === 'gmail.com') {
                fetchCompanyDetails(response.data[0] && response.data[0].userData && response.data[0].userData[0].customer_metadata.companyName)
               }
            }
            setActive_status(response.data[0].userData[0].active_status)
            setUserId(response.data[0].userData[0].user_id)
            setDefaultCompanyValues(response.data[0] && response.data[0].userData && response.data[0].userData[0].customer_metadata)
            setDefaultContactValues(response.data[0] && response.data[0].userData && response.data[0].userData[0].customer_metadata)
          }
          if(response.data[0].customer_status && response.data[0].customer_status === 2){
            setIsExistingCustomer(true)
          }
          setIcon(true)
          setType('error')
          setMessage("Customer with same email id already exists")
          setNotification(true)
          setTimeout(() => {
            setNotification(false)
          }, 3000);
        }
        //<<NEW USER>>//
        if( response && response.status === 1) {
          setFlag(false)
          setStatus(response.status)
          setApiStatus(response.status)
          setActive_status(1)
          setDefaultCompanyValues(response.data)
        }
        //<<MATCHING DOMAIN>>//
        if ( response && response.status === 3) {
          
          setFlag(false)
          setApiStatus(response.status)
          setIsExistingCustomer(true)
          if(response.data[0].userData){
            setActive_status(response.data[0].userData[0].active_status)
            setUserId(response.data[0].userData[0].user_id)
            setDefaultCompanyValues(response.data[0] && response.data[0].userData && response.data[0].userData[0].customer_metadata)
            setDefaultContactValues(response.data[0] && response.data[0].userData && response.data[0].userData[0].customer_metadata)
          }
          if(!response.data[0].userData){
            setActive_status(1)
            setDefaultCompanyValues(response.data[0] && response.data[0].customer_metadata)
            setDefaultContactValues(response.data[0] && response.data[0].customer_metadata)
          }
          setMessage('Your company already exists on Ellow platform,Company details will be prefilled and you would be added as an additional user post completing the registration process')
          setStatus(response.status)
          setIcon(true)
          setType('success')
          setNotification(true)
          setTimeout(() => {
            setNotification(false)
          }, 5000);
        }
        //<<BACKEND ERROR>>//
        if ( response && response.status === 2) {
          // setMessage('Failed, please try again later!')
          // setNotification(true)
          // setTimeout(() => {
          //   setNotification(false)
          // }, 3000);
        }

        if (response && response.status === 5) {
          setIcon(false)
          setType('error')
          setMessage('Sorry! Unable to process. Please contact at team@ellow.io')
          setBlackListed(true)
          setNotification(true)
          setTimeout(() => {
            setNotification(false)
          }, 3000);
        }
    
      })
      .catch((err: any) => {
    
      })
    
      }

    const items = [
        {
          label: "Contact Details",
          icon: "one",
        },
        {
          label: "Company Details",
          icon: "two",
        },
        // {
        //   label: "Schedule a call",
        //   icon: "three",
        // }
      ];

    const Back = () => { 
      setStep(step - 1)
      const mail = localStorage.getItem('email') || email
      setFlag(true)
      getCustomerDetails(mail)
    }

  const onSubmit = (data: any) => {
    
    if (blackListed) {
      setIcon(false)
      setType('error')
      setMessage('We are unable to process this request,  Please reach out to team@ellow.io')
      setNotification(true)
      setTimeout(() => {
        setNotification(false)
      }, 5000);
      return
    }

    if (!flag) {
      let body = {
        "customerMetadata": {
          "workEmail": data.workEmail,
          "phoneNumber": data.phoneNumber,
          "companyName": data.companyName,
          "firstName": data.firstName,
          "designation": data.designation,
          "googleLocations": data.googleLocations
        },
        "submittedBy": "PROVIDER",
        "companyType": 2,
        "customerStatus": 1
      }
      addProviderDetails(body).then((response) => {
        if (response && response.status === 1) {
          mixpanelData('New ML - Registration drafted', {
            'Source': 'Contract details updated',
            "Work email": data.workEmail,
            "Phone number": data.phoneNumber,
            "Company name": data.companyName,
            "Name": data.firstName,
            "Designation": data.designation,
            "distinct_id": data.workEmail,
            'customer_id': response.data.customer_id
          }) 
          setStep(step + 1)
          setCustomerId(response.data.customer_id)
          setFlag(true)
          setEmail(data.emailId)    
          setUserId(response.data.userId)
          setActive_status(response.data.activeStatus)
        }
      })
    } 
    if(flag && active_status < 2) {   
      
        let body = {
          "customerMetadata": {
            "services": data.services,
            "domains": data.domain,
            "skills": data.skills,
            "workEmail": data.workEmail,
            "phoneNumber": data.phoneNumber,
            "companyName": data.companyName,
            "firstName": data.firstName,
            "designation": data.designation,
            "googleLocations": data.googleLocations
          },
          "submittedBy": "PROVIDER",
          "companyType": 2,
          "customerStatus": data.customerStatus,
          "userId": userId,
          "customerId": customerId,
          "isExistingCustomer": isExistingCustomer
        }
        updateProviderDetails(body).then((response) => {
          if (response && response.status === 1) {
            mixpanelData('New ML - Registration Completed', {
              'Source': 'Contract details updated',
              "Work email": response.data.customer_metadata.workEmail,
              "Phone number": response.data.customer_metadata.phoneNumber,
              "Company name": response.data.customer_metadata.companyName,
              "Name": response.data.customer_metadata.firstName,
              "Designation": response.data.customer_metadata.designation,
              "distinct_id": response.data.customer_metadata.workEmail,
              'Company id': customerId,
              "Services": data.services && data.services.length > 0 && data.services.map((item: any) => item.name),
              "Domains": data.domain && data.domain.length > 0 && data.domain.map((item: any) =>item.name),
              "Skills": data.skills && data.skills.length > 0 && data.skills.map((item: any) => item.name),
              "Locations": data.googleLocations && data.googleLocations.length > 0 && data.googleLocations.map((item: any) => item.name)
            })
            setStep(step + 1)
            if(response.data.activeStatus === 2){
              navigate('/verification')
            }
            mixpanelData('ML- Provider updates basic details', {
              'source': 'Excisting provider updates basic details',
              "workEmail": data.workEmail,
              "phoneNumber": data.phoneNumber,
              "companyName": data.companyName,
              "firstName": data.firstName,
              "services": data.services && data.services.length > 0 && data.services.map((item: any) => item.name),
              "domains": data.domains && data.domains.length > 0 && data.domains.map((item: any) => item.name),
              "skills": data.skills && data.skills.length > 0 && data.skills.map((item: any) => item.name),
              "designation": data.designation,
              "distinct_id": data.workEmail
            })
          }
        })
     
    }

    if ( active_status === 2) {
      navigate('/verification')
    }
    if (active_status > 3) {
      if (active_status === 5 || active_status === 6 || active_status === 7 || active_status === 8) {
        setType('error')
        setIcon(false)
        setMessage('We are unable to process this request,  Please reach out to team@ellow.io')
        setNotification(true)
        setTimeout(() => {
          setNotification(false)
        }, 5000);
      }
      navigate('/login')
    }
  }

  const mixpanelDraft = (data: any, response : any) => {
    mixpanelData('New ML - Registration drafted', {
      'Source': 'Contract details updated',
      "Work email": data.workEmail,
      "Phone number": data.phoneNumber,
      "Company name": data.companyName,
      "Name": data.firstName,
      "Designation": data.designation,
      "distinct_id": data.workEmail,
      'Company id': customerId ? customerId : response.data.customer_id
    }) 
 }

  const fetchCompanyDetails = (data: any) => {
    let value = encodeURI(data)
    getCompanyDetails(value).then((response) => {
      if (response && response.status === 1) {
        setIsExistingCustomer(true)
        // setActive_status(1)
        setCustomerId(response.data[0].customer_id)
        setCompanyFlag(true)
        setStatus(response.data[0].customer_status)
        setDefaultCompanyValues(response.data[0] && response.data[0].customer_metadata)

      }
    })
  }

  const onBlur = (data: any) => {    
    getCustomerDetails(data)
  }

  const onClose = () => {
    setNotification(false)
  }
  
  return (
    <section className={Styles.profileWrapper}>
    <div className={Styles.header}>
      <img src={ellowLogo} alt="ellow.io" />
    </div>
    <div className={Styles.headline4}>
        <Headline4>Please provide your details </Headline4>
      </div>
      <p className={Styles.subtitle}>We at ellow.io practice high security standards to keep the data you enter safe and secured</p>

    <div className="container">
      <div className={Styles.profileStepper}>
      <StepperDefault items={items} value={step} />
      </div>
      <div className={Styles.profileSteps}>
        <div className={Styles.profileStepForm}>
            {step === 0 && <ContactDetails clickHandler={onSubmit} onBlur={onBlur} defaultValues={defaultContactValues} status={apiStatus} fetchCompanyDetails={fetchCompanyDetails} />}
            {step === 1 && <CompanyDetails clickHandler={onSubmit} back={Back} defaultValues={defaultCompanyValues} providerDomains={providerDomains} customerId={customerId} domainsList={domainsList}  getProviderDomainsList={getProviderDomainsList} jobRolesList={jobRoleList} skillsList={skillList} />}
            {/* {step === 2 && <Calendly  Back={Back} />} */}
        </div>
      </div>
      {notification && <NotificationAlert onClose={onClose } type={type} icon={icon} closable={true} > {message} </NotificationAlert> }
    </div>
  </section>
  )
}

export default Registration